module.exports = __webpack_public_path__ + "static/media/momo.c35102e6.png";